<i18n>
{
  "de": {
    "email": "E-Mail",
    "nickName": "Nickname",
    "submit": "Absenden",
    "cancel": "Abbrechen",
    "confirmData": "Vielen Dank, wir legen nun ein Konto für Dich an. Bitte bestätige oder vervollständige Deine Daten. Bitte beachte auch, dass Dein Nickname danach nicht änderbar ist."
  },
  "en": {
    "email": "Email",
    "nickName": "Nickname",
    "submit": "Submit",
    "cancel": "Cancel",
    "confirmData": "Thank you, we will now create an account for you. Please confirm or complete your data. Please also note that your nickname cannot be changed afterwards."
  }
}
</i18n>

<template>
  <form
    novalidate
    method="post"
    autocomplete="off"
    @submit.prevent="emitValid"
  >
    <div class="columns is-gapless is-formfields">
      <div class="column">
        <p>{{ $t('confirmData') }}</p>
        <input-text
          id="email"
          v-model="email"
          :label="$t('email')"
          name="email"
          scope="fb"
          :validate="emailValidation"
          class="is-medium"
        />
      </div>
    </div>
    <div class="columns is-gapless is-formfields">
      <div class="column">
        <input-text
          id="nickname"
          v-model="nickname"
          name="nickname"
          :label="$t('nickName')"
          scope="fb"
          :validate="nicknameValidation"
          class="is-medium"
        />
      </div>
    </div>
    <div class="control mt-50">
      <div class="button-column-group">
        <button
          id="submit-recovery"
          type="submit"
          :disabled="errors.any('fb')"
          class="button is-primary is-outlined is-fullwidth is-medium"
        >
          {{ $t('submit') }}
        </button>
        <button
          style="margin-left: 0px !important"
          class="button mt-20 is-outlined is-fullwidth is-medium is-in-column"
          @click.prevent="emitCancel"
        >
          {{ $t('cancel') }}
        </button>
      </div>
      <input
        type="submit"
        style="position: absolute; left: -9999px"
      >
    </div>
  </form>
</template>

<script>
export default {
  name: 'socialLoginFormComponent',
  serverCacheKey: () => 'social-login-form-component',
  props: ['user'],
  components: {},
  data: () => ({
    email: '',
    nickname: ''
  }),

  mounted() {
    this.email = this.user.socialData.email
    this.nickname = this.user.socialData.nickname
  },
  computed: {
    emailValidation() {
      return `required|validEmailAddress|uniqueEmailAddress:${this.user.id}`
    },
    nicknameValidation() {
      return `required|uniqueNickname:${this.user.id}`
    }
  },
  methods: {
    async emitValid() {
      const valid = await this.$validator.validate('fb.*')
      if (valid) {
        this.$emit('valid', {
          email: this.email,
          nickname: this.nickname
        })
      }
    },
    clearValidator() {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    emitCancel() {
      this.clearValidator()
      this.$emit('cancelled')
    }
  }
}
</script>
